{
  "Id": "EU IRIA:",
  "IdPlaceholder": "[Auto atribuído]",
  "NamePlaceholder": "Ambiente de Gerenciamento Central",
  "BillingId": "Código de cobrança:",
  "ParentCme": "CME principal:",
  "DescriptionIsRequired": "A descrição é obrigatória.",
  "CMEDetails_ButtonHelpLabel": "Ajuda?",
  "CMEDetails_ButtonSubmitLabel": "OK",
  "CMEDetails_ButtonCancelLabel": "Cancelar",
  "CMEDetails_PromptMessage": "Tem certeza de que deseja fechar esta janela? Todas as configurações modificadas serão perdidas quando fechadas.",
  "CMEDetails_PromptConfirm": "sim",
  "CMEDetails_PromptCancel": "Cancelar",
  "CMEDetails_Description": "Descrição:",
  "NAME": "CMEDetails",
  "CMEDetails_ProviderIDS": "IDs de fornecedor de SSO:",
  "CMEDetails_ProviderIDS_Help": "Deixe em branco, a menos que esteja a configurar o Single-Sign On (SSO). O seu ID de fornecedor terá sido fornecido se estiver a utilizar o SSO.",
  "CMEDetails_ProviderIDS_Validation_NoMoreThan5": "Não são permitidos mais de 5 IDs de fornecedor de SSO.",
  "CMEDetails_ProviderIDS_Validation_IDsInvalid": "Certifique-se de que os ID de fornecedor são apenas letras, números, hífenes ou sublinhados, não têm mais de 15 caracteres e estão numa lista separada por vírgulas.",
  "CMEDetails_Disable_Akixi_Login": "Desativar a capacidade de início de sessão do nome de utilizador:"
}